// removed by extract-text-webpack-plugin
module.exports = {"size":"125px","image":"Gd840aa","placeholder":"G15523f"};